import { default as React } from "react"
import { Highlight, Hits, Index, Snippet } from "react-instantsearch-dom"
import { formatDate } from "../../utils/event"
import { Block } from "../content-section"
import Cta from "../cta"
import { Link } from "gatsby"

const EventHit = ({ hit }) => {
  return (
    <Block props={{
      heading: <Highlight attribute="title" hit={hit} tagName="mark" />,
      subheading: formatDate(hit.eventInformation?.timeDate?.startDate, hit.eventInformation?.timeDate?.startTime, hit.eventInformation?.timeDate?.endDate, hit.eventInformation?.timeDate?.endTime, hit.eventInformation?.allDay, "startDate"),
      cta: {
        url: hit.slug,
        title: "Explore",
      },
      image: hit.featuredImage?.node,
      content: formatDate(hit.eventInformation?.timeDate?.startDate, hit.eventInformation?.timeDate?.startTime, hit.eventInformation?.timeDate?.endDate, hit.eventInformation?.timeDate?.endTime, hit.eventInformation?.allDay, "time"),
    }} />
  )
}
const PageHit = ({ hit }) => {
  return (
    <div className="py-12 px-6 border-b border-green/25 h-full">
      <Link className="block" to={hit.slug}>
        <h3 className="mb-1 text-body hover:text-black ">
          <Highlight attribute="title" hit={hit} tagName="mark" />
        </h3>
        <p className="text-sm uppercase font-medium mb-1"><Highlight attribute="date" hit={hit} tagName="mark" /></p>
      </Link>
      <div className="parsed-content text-sm mb-1"><Snippet attribute="excerpt" hit={hit} tagName="mark" /> <Cta props={{ url: hit.slug, title: "Read more" }} /></div>
    </div>
  )
}

const HitsInIndex = ({ index }) => {
  return (
    <Index indexName={index.name}>
      <Hits className="Hits" hitComponent={index.name === "Events" ? EventHit : PageHit} />
    </Index>
  )
}

const SearchResult = ({ indices }) => {
  return (
    <div>
      {indices.map(index => (
        <HitsInIndex index={index} key={index.name} />
      ))}
    </div>
  )
}

export default SearchResult
